import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brandName, outcomes } from '../data/copy';
export function FinalCtaSection() {
  const negatives = outcomes.filter(outcome => !outcome.positive);
  const positives = outcomes.filter(outcome => outcome.positive);
  return <section className="defer-paint w-full bg-surface py-12 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-64" data-mp="3vrkxpiy7qddw">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-65" data-mp="2y66pcg38rs5f">
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-accent" data-id="element-66" data-mp="333p1efck2nhn">Da domani mattina</p>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-serif text-[2.3rem] font-bold leading-[1.05] text-ink sm:text-[3rem]" data-id="element-67" data-mp="382s0lj5utzhp">
          La tua prossima classe{' '}
          <span className="text-accent" data-id="element-68" data-mp="2few34c8go3jv">inizia oggi</span>
        </h2>

        <div className="mx-auto mt-10 grid max-w-3xl gap-4 text-left sm:grid-cols-2" data-id="element-69" data-mp="2fcjmc2efvz8e">
          <div className="rounded-3xl border border-line bg-canvas p-6" data-id="element-70" data-mp="2kbcr96fnuhwy">
            <h3 className="font-serif text-2xl font-bold text-ink" data-id="element-71" data-mp="2dap0y7s6f0zs">
              Non hai più bisogno di
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-72" data-mp="28f07mm6r2gbx">
              {negatives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed text-muted" data-id="element-73" data-mp="23kvypxdxby87">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-muted" strokeWidth={2.6} aria-hidden="true" data-id="element-74" data-mp="1yl16nqiex2lk" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border border-accent/30 bg-card p-6" data-id="element-75" data-mp="1poih8o9e3wtq">
            <h3 className="font-serif text-2xl font-bold text-accent" data-id="element-76" data-mp="1ko4ad9jiysxa">
              Con {brandName}
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-77" data-mp="1fq2nsemw4bh2">
              {positives.map(outcome => <li key={outcome.text} className="flex items-start gap-2.5 font-sans text-[0.88rem] font-semibold leading-relaxed text-ink" data-id="element-78" data-mp="3f0areoz3o3xi">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-79" data-mp="3a0g4sxmcy0i9" />
                  {outcome.text}
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton size="large" className="mt-10" data-id="element-80" data-mp="yexj1i3on0rh">
          Accedi a {brandName} adesso
        </CtaButton>
        <p className="mt-4 font-sans text-[11px] text-muted" data-id="element-81" data-mp="13dqtf1noabnf">
          Pagamento sicuro · accesso immediato · garanzia di 7 giorni
        </p>
      </div>
    </section>;
}